import { EventEmitter, Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { environment } from 'src/environments/environment'
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HeaderService {
  darkTheme = new EventEmitter<boolean>()

  constructor(
    private httpClient: HttpClient
  ) {}


  // constructor() {}

  toggleDarkTheme(darkThemeFlag: boolean) {
    this.darkTheme.emit(darkThemeFlag)
  }
}
